// The "Text Shimmer" ramps from Figma, whose base colour is picked to sit against the text it replaces.
const SHIMMER_ACCENTS = {
  red: '#D08282',
  orange: '#DF9C6E',
  blue: '#99B9E2',
  lavender: '#A49EBC',
} as const

const SHIMMER_BASES = {
  default: '#272962',
  strong: '#21201C',
  muted: '#63635E',
  subtle: '#8D8D86',
} as const

const textShimmer = (base: string) =>
  `linear-gradient(89deg, ${base} 20%, ${SHIMMER_ACCENTS.red} 30%, ${SHIMMER_ACCENTS.orange} 40%, ${SHIMMER_ACCENTS.blue} 60%, ${SHIMMER_ACCENTS.lavender} 70%, ${base} 80%)`

export const gradients = {
  'text-shimmer-default': textShimmer(SHIMMER_BASES.default),
  'text-shimmer-strong': textShimmer(SHIMMER_BASES.strong),
  'text-shimmer-muted': textShimmer(SHIMMER_BASES.muted),
  'text-shimmer-subtle': textShimmer(SHIMMER_BASES.subtle),
} as const
